'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionsAllPurchasableController = function () {
    function SelectionsAllPurchasableController($scope, $rootScope, ApiSelections, $ionicLoading, $q, $state, $stateParams, $ionicScrollDelegate, ApiDashboard) {
        _classCallCheck(this, SelectionsAllPurchasableController);

        this.$rootScope = $rootScope;
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.ApiSelections = ApiSelections;
        this.selections = [];
        this.selectionsPromise = $q.defer();
        this.$stateParams = $stateParams;
        this.showStartupHelpWizard = $stateParams.showHelp;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.ApiDashboard = ApiDashboard;
    }

    _createClass(SelectionsAllPurchasableController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            this.ApiSelections.getSelections().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.selections = res;
                    _this.selections.forEach(function (selection) {
                        delete selection.relatedSelection;
                    });
                    _this.hideContainerFromPackages();
                    _this.selectionsPromise.resolve(res);
                    _this.selections.loaded = true;
                    _this.$ionicLoading.hide();
                } else {
                    _this.$ionicLoading.hide();
                }
            });

            this.isStartupDisplayed = this.ApiDashboard.isStartupDisplayed;
        }

        /**
         * Hard-code to remove 2 container packages `Other Investors` & `Pension & Insurance`
         * @link https://toolchain.logicline.de/jira/browse/AIC-953
         * @return {void}
         */

    }, {
        key: 'hideContainerFromPackages',
        value: function hideContainerFromPackages() {
            var container = ['Pension & Insurance', 'Other Institutionals'];
            this.selections = this.selections.filter(function (s) {
                return !container.includes(s.selectionName);
            });
        }
    }, {
        key: 'filterPension',
        value: function filterPension(selection) {
            return selection.subtitle && selection.subtitle.includes('Pension') && !selection.subtitle.includes('Insurance');
        }
    }, {
        key: 'filterInsurance',
        value: function filterInsurance(selection) {
            return selection.subtitle && !selection.subtitle.includes('Pension') && selection.subtitle.includes('Insurance');
        }
    }, {
        key: 'filterBoth',
        value: function filterBoth(selection) {
            return selection.subtitle && selection.subtitle.includes('Pension') && selection.subtitle.includes('Insurance');
        }
    }, {
        key: 'filterOther',
        value: function filterOther(selection) {
            return selection.subtitle && !selection.subtitle.includes('Pension') && !selection.subtitle.includes('Insurance');
        }
    }, {
        key: 'setSearchPerformedSignal',
        value: function setSearchPerformedSignal() {

            this.$ionicScrollDelegate.scrollTop();
            this.$rootScope.$broadcast('searchPerformed');
        }
    }]);

    return SelectionsAllPurchasableController;
}();

exports.default = SelectionsAllPurchasableController;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selectionsAllPurchasable.controller.js
 **/